const QsErrorEvent = 'QsErrorEvent'
export const logError = (...args: Parameters<typeof console.error>) => {
  window.dispatchEvent(new CustomEvent(QsErrorEvent, { detail: args }))
  console.error(...args)
}
